import { useTranslation } from 'react-i18next'
import { useAppStore } from '@/store/appStore'
import { useContentBundle } from '@/hooks/useContentBundle'
import { useActiveFilterChips, useFilterChipLabels } from '@/hooks/useFilterChips'
import { FilterChips } from '@/components/content/FilterChips'

/** Key for the tree's framework and context markers. Each entry shows or hides its markers. */
export function FilterLegend() {
  const { t } = useTranslation()
  const { data: bundle } = useContentBundle()
  const chips = useActiveFilterChips(bundle)
  const hiddenKeys = useAppStore((s) => s.hiddenFilterChipKeys)
  const toggleHidden = useAppStore((s) => s.toggleFilterChipHidden)
  const setLabels = useAppStore((s) => s.setFilterChipLabels)
  const labels = useFilterChipLabels()

  if (!chips) return null

  return (
    <div className="filter-legend" role="group" aria-label={t('filterChips.legend')}>
      <ul className="filter-legend-items">
        {chips.map((chip) => {
          const shown = !hiddenKeys.includes(chip.key)
          return (
            <li key={chip.key}>
              <button
                type="button"
                className={`filter-legend-item${shown ? '' : ' filter-legend-item--hidden'}`}
                aria-pressed={shown}
                title={chip.title}
                onClick={() => toggleHidden(chip.key)}
              >
                <FilterChips chips={[chip]} variant="markers" decorative />
                <span className="filter-legend-label">{chip.label}</span>
              </button>
            </li>
          )
        })}
      </ul>
      <button
        type="button"
        className="filter-legend-labels"
        aria-pressed={labels}
        onClick={() => setLabels(!labels)}
      >
        {t('filterChips.showLabels')}
      </button>
    </div>
  )
}
